import React from "react";
import { ArrowBackCircle } from "react-ionicons";
import constantURI from "../URI";
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter";
import stylesASAP from "./stylesASAP";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import stylesMed from "../MedRep/stylesMed";
import _postBody from "../Functions/Post";
import { db, getDocs, collection, disableNetwork } from "../firebase";
import { set, get } from "idb-keyval";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ProgressBar from "react-bootstrap/ProgressBar";

export default class Log extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      UST: [],
      noData: true,
      SoRo: true,
      alertUndefined: false,
      showAlertimage: false,
      percentage: 0,
      exist: "",
      trans: [],
    };
  }

  async componentDidMount() {
    const UST = JSON.parse(localStorage.getItem("DailyData"));
    const Trans = JSON.parse(localStorage.getItem("UnsyncedTransactions"));
    const SoRo = JSON.parse(localStorage.getItem("OrderType"));
    await this.setState({ UST: UST, USTCopy: UST, SoRo: SoRo, trans: Trans });
    // await this.sortItems();
  }
  // sortItems = () => {
  //   const UST = this.state.UST[0];
  //   if (this.state.UST[0] !== undefined && this.state.UST[0] !== null) {
  //     const sortedData = [...UST].sort((a, b) => a.date_order - b.date_order);
  //     this.setState({ UST: [sortedData] });
  //   }
  // };

  showAlertimage = async (index , itemIndex) => {
    this.setState({
      showAlertimage: true,
      alertUndefined: false,
      percentage: 0,
    });
    this.Resend(index , itemIndex);
  };

  closeAlertimage = () => {
    this.setState({ showAlertimage: false });
  };
  onSearch = async (text) => {
    var values = await SearchFilterFunction(
      text,
      this.state.UST[0],
      this.state.USTCopy[0],
      this.state.noData
    );
    this.setState({
      UST: [values.items],
      noData: values.noData,
    });
  };
  Resend = async (index , itemIndex) => {
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    await this.setState({ percentage: 10 });

    if (this.state.authenticate) {
      await this.setState({ percentage: 20 });
      if (this.state.UST !== undefined && this.state.UST !== null) {
        const SO = this.state.UST[index][itemIndex];
        await this.setState({ percentage: 25 });
        await _postBody(SO.createURL, SO.Body).then(async (response) => {
          if (response.status === 200) {
            await this.setState({ percentage: 35 });
            console.log(SO.createURL);
            console.log(JSON.stringify(SO.Body));
            return response.json().then(async (data) => {
              console.log(data);
              this.setState({ percentage: 40 });
              if (data.result !== undefined && data.result !== null) {
                if (data.result.results[0].success) {
                  console.log(data.result.results[0].recordID);
                  SO.signatureUrl =
                    SO.signatureUrl.substring(
                      0,
                      SO.signatureUrl.indexOf("&id=") + 4
                    ) + data.result.results[0].recordID;
                  this.setState({ percentage: 70 });
                  var body = {};
                  body.signature = SO.signature;
                  await _postBody(SO.signatureUrl, body).then((response) => {
                    return response.json().then(async (data) => {
                      if (data.result === undefined) {
                        this.setState({ alertUndefined: true });
                        SO.updateState = "Unsynced";
                      } else {
                        SO.updateState = "Synced";
                      }
                      this.setState({ percentage: 100, showAlertimage: false });
                    });
                  });
                } else {
                  this.setState({
                    alertUndefined: true,
                    exist: "This Transaction already exists in Odoo",
                  });
                  this.setState({ percentage: 100 });
                }
              } else {
                this.setState({ alertUndefined: true });
                this.setState({ percentage: 100 });
              }
            });
          }
        });
      }
    } else {
      alert("Please connect to the internet.");
    }
  };

  formatDate = (fullDate) => {
    const dateObject = new Date(fullDate);
    dateObject.setHours(0);
    dateObject.setMinutes(0);
    dateObject.setSeconds(0);
    console.log(dateObject);
    const formattedDate = dateObject;
    console.log(formattedDate);
    return formattedDate;
  };

  onSelectToDate = async (date) => {
    await this.setState({ toDate: date });

    // let day = date.getDate();
    // let month = date.getMonth() + 1;
    let day = String(date.getDate()).padStart(2, "0");
    let month = String(date.getMonth() + 1).padStart(2, "0");
    let year = date.getFullYear();
    let currentDate = date;
    console.log(date);

    const filteredItems = this.state.USTCopy[0].filter((item) => {
      const itemDate = this.formatDate(item.date_order);
      return itemDate.toLocaleString() === currentDate.toLocaleString();
    });
    this.setState({ UST: [filteredItems] });
  };

  render() {
    console.log(this.state.UST);
    return (
      <div className="container-fluid vh-100" style={stylesASAP.mainContainer}>
        {this.state.trans.length !== 0 ? (
          <div>
            <div className="col">
              <ArrowBackCircle
                className="btn col"
                onClick={() => this.props.history.push("./LandingPage")}
                color={"#00bfff"}
                height="50px"
                width="50px"
              />
            </div>
            <h3 className="text-center text-danger mt-5">
              There is Unsynced Transaction , Please Send them Before...
            </h3>
          </div>
        ) : (
          <div>
            <div className="pt-3 row">
              <div className="col">
                <ArrowBackCircle
                  className="btn col"
                  onClick={() => this.props.history.push("./LandingPage")}
                  color={"#00bfff"}
                  height="50px"
                  width="50px"
                />
              </div>
            </div>
            <div className="pt-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search Here"
                onChange={(text) => this.onSearch(text)}
              />
            </div>
            <p className="pt-3 text-center h2">LOG Sales Orders</p>
            <div className="col-sm-3">
              <h6>Filter By Date</h6>
              <DatePicker
                className="form-control"
                selected={this.state.toDate}
                onChange={(date) => this.onSelectToDate(date)}
              />
            </div>
            <div>
 
{
  // Ensure UST exists
  Array.isArray(this.state.UST) && this.state.UST.length > 0
    ? this.state.UST.flatMap((group, groupIndex) => {
        // Skip null or empty groups
        if (!group || group.length === 0) return [];

        // Map each item in the group
        return group.map((item, itemIndex) => {
          if (!item) return null; // skip null items

          return (
            <div key={`${groupIndex}-${itemIndex}`} className="card-text row mt-5">
              <div className="col-10">
                <div className="table row">
                  <div className="unsynced col-1 h6 mt-2">Name</div>
                  <div className="col-2 h6 mt-2">{item.partner_id?.[1] || 'N/A'}</div>

                  <div className="unsynced col-1 h6 mt-2">Date</div>
                  <div className="col-3 h6 mt-2">{item.date_order || 'N/A'}</div>

                  <div className="unsynced col-1 h6 mt-2">Total</div>
                  <div className="col-2 h6 mt-2">{item.amount_total ?? 0} {item.currency_id?.[1] || ""}</div>

                  <div className="unsynced col-1 h6 mt-2">Type</div>
                  <div className="col-1 h6 mt-2">{item.name || 'N/A'}</div>
                </div>
              </div>

              <div className="col-2 mt-1">
                <button
                  className="btn btn-primary"
                  onClick={() => this.showAlertimage(groupIndex , itemIndex )}
                >
                  <h5>Re-Send</h5>
                </button>
              </div>
            </div>
          );
        });
      })
    : null
}


            </div>
            <Modal
              show={this.state.showAlertimage}
              onHide={this.closeAlertimage}
              animation={false}
            >
              <Modal.Body>
                <div>
                  {this.state.alertUndefined ? (
                    <div>
                      <h3 className="pt-5 text-center">
                        Something went wrong...
                      </h3>
                      <h3 className="pt-5 text-center text-danger">
                        {this.state.exist}
                      </h3>
                    </div>
                  ) : (
                    <div>
                      <h3 className="text-center">
                        This may take few seconds.
                      </h3>
                      <ProgressBar animated now={this.state.percentage} />
                      <h3 className="text-center mt-1">
                        {this.state.percentage}%
                      </h3>
                    </div>
                  )}
                </div>
              </Modal.Body>
            </Modal>
            {/* <div>
          {this.state.UST.map((transaction) => {
            transaction.map((SO) => {
              return (
                <div className="row  mt-3">
                  <div>{SO.partner_id[1]}</div>
                </div>
              );
            });
          })}
        </div> */}
          </div>
        )}
      </div>
    );
  }
}
